export const useAssetDetails = () => {
  const patchAssetDetails = (data) => {
    //TODO ==> missing async patchLoanDetails request here
    console.log('ASSET DETAILS HANDLER --> TODO patchAssetDetails', { data });
  };
  return { patchAssetDetails };
};
